// extracted by mini-css-extract-plugin
module.exports = {"search-fade-in":"OfficesJobSearch_search-fade-in__MV2Gd"};